import React from 'react';

interface IProps{
    className?: string,
    errorMessage?: string;
    id: string;
}

const InputErrorContainer = ({ className, errorMessage, id } : IProps) => (
  <div
    className={`
  ${className}
      transition-[ visibility] duration-500 linear
      ${!errorMessage ? 'pt-[0px] invisible' : 'pt-[0.5rem] visible max-w-full break-words'}`}
  >
    <h2 id={id} className='text-red02 font-metric text-sm max-w-[384px]'>{errorMessage || ''}</h2>
  </div>
);

export default InputErrorContainer;
